export default {
  data() {
    return {
      cards: [],
    };
  },
  computed: {
    processedProducts() {
      const processedProducts = [];
      let photoIds = [];

      if (this.myOrder && this.myOrder.photos && !!this.myOrder.photos.length) {
        this.myOrder.photos.forEach(photo => {
          if (photo && photo.id) {
            photoIds.push(photo.id);
          }
        });
      }

      if (this.products && photoIds) {
        this.products.forEach(product => {
          if (product.blockedAlbumItems) {
            const blockedAlbumItems = [];

            product.blockedAlbumItems.forEach(item => {
              if (photoIds.indexOf(item) >= 0) blockedAlbumItems.push(item);
            });

            product.disabled = !!blockedAlbumItems.length;
          } else {
            product.disabled = false;
          }

          processedProducts.push(product);
        });
      }

      return processedProducts;
    }
  },
  methods: {
    next(id) {
      const product = this._.find(this.products, {id});

      if (product.sets) {
        this.selectSets(product);
      } else {
        this.selectProductCategory(product);
      }
    },
    viewProductCategory(item) {
      this.$store.dispatch('ADD_PREV_ORDER_STEP', this.orderStep);
      this.$store.dispatch('SET_ORDER_STEP', `${this.orderStep}-view`);
      this.$store.dispatch('SET_VIEW_PRODUCT', item);
    },
  },
  created() {
    if (this.products) {
      this.products.forEach(product => this.cards.push({show: !product.image}));
    }
  },
};
